import { makeDoneOwnPending } from "api/Pendings"
import { useMutation, useQueryClient } from "react-query"
import { toast } from "react-toastify"


export const useMakeDoneOwnPending = () => {
    const queryClinet =  useQueryClient();
    return useMutation(makeDoneOwnPending,{
        onSuccess: () => {
            queryClinet.invalidateQueries('ownPendings');
            queryClinet.invalidateQueries(['widgetData','Own Pendings List'])
            toast.success('Pending is done')
        },
        onError: () => {
            toast.error('Something went wrong!')
        }
    })
}